import React from "react";

const SnapDataTable = ({
  // SnapDataBox Props
  title,
  value,
  subtext = "",
  valueClassName = "",

  // Table Props
  columns = [],
  data = [],
  visibleRows = 5,
  className = "",
  ...rest
}) => {
  return (
    <>
      <style>{`
        /* ===== MAIN CONTAINER ===== */
        .snap-widget-container {
          display: flex;
          flex-direction: column;
          border-radius: 12px;
          border: 1px solid var(--border-color);
          background-color: var(--base-200);
          overflow: hidden; /* Keeps child elements inside the rounded corners */
        }

        /* ===== SCROLLABLE TABLE AREA ===== */
        .table-scroll-area {
          --row-height: 5vh;
          width: 100%;
          /* Limits height based on visibleRows */
          max-height: calc(var(--row-height) * ${visibleRows});
          overflow-y: auto;
          overflow-x: auto;
        }

        .snap-table {
          width: 100%;
          border-collapse: collapse;
          text-align: left;
          color: var(--font-primary);
        }

        /* ===== BODY ===== */
       .snap-table td {
        height: var(--row-height);
        padding: 0.7rem 1rem;
        font-size: 12px;
        border-bottom: 1px solid var(--border-color);
        color: var(--font-primary);
        white-space: normal;
        overflow-wrap: break-word;
        word-break: break-word;
        overflow: visible;
        text-overflow: unset;
        }

        @media only screen and (max-width: 768px) {
          .snap-table td{
          height: calc(var(--row-height) - 1vh);
          padding: 0.5rem 1.25rem;
          font-size: 12px;
          background-color: transparent;
          border-top: 1px solid var(--border-color);
          }
        }

        .snap-table td:first-child {
          text-align: left;
        }
        
        .snap-table td:last-child {
          text-align: right;
        }

        .snap-table tbody tr:last-child td {
          border-bottom: none;
        }

        .snap-table tbody tr {
          transition: background-color 0.15s ease;
        }

        .snap-table tbody tr:hover {
          background-color: var(--primary10);
        }

        /* ===== EMPTY STATE ===== */
        .snap-table .empty-cell {
          text-align: center;
          padding: 2rem;
          color: var(--font-secondary);
          font-size: 13px;
        }
      `}</style>

      <div className={`snap-widget-container ${className}`} {...rest}>
        {/* TOP: The Snap Data Box */}
        <div className="snap-data-box">
          <div className="snap-box-title">{title}</div>
          <div className="snap-box-value-box" style={{flexDirection:"column", rowGap:"5px"}}>
            <div className={`snap-box-value ${valueClassName}`}>{value}</div>
            {subtext && <div className="snap-box-subtext">{subtext}</div>}
          </div>
        </div>

        <div className="table-scroll-area">
          <table className="snap-table">
            <tbody>
              {data !== null && data.length > 0 ? (
                data.map((row, rowIndex) => (
                  <tr key={rowIndex}>
                    {columns.map((col, colIndex) => (
                      <td key={colIndex}>{row[col]}</td>
                    ))}
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={columns.length || 1} className="empty-cell">
                    No data available
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
};

export default SnapDataTable;
